export default {
      id: "arrow-usage",
      viewBox: "0 0 9 5",
      url: __webpack_public_path__ + "sprite.svg#arrow",
      toString: function () {
        return this.url;
      }
    }